import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          精彩片段
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          热门综艺片段速览，精彩不容错过
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mb-2 inline-block">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}